import { Pipe, PipeTransform } from '@angular/core';

interface RequirementFilterItem {
  RequirementName: string;
}

@Pipe({
  name: 'requirementFilter',
  standalone: false,
})
export class RequirementFilterPipe implements PipeTransform {
  transform(
    value: RequirementFilterItem[] | undefined,
    args: string
  ): RequirementFilterItem[] | undefined {
    if (!args) return value;
    const filter = args.toLocaleLowerCase();
    return filter
      ? value.filter(
          (customer) =>
            customer.RequirementName.toLocaleLowerCase().indexOf(filter) !== -1
        )
      : value;
  }
}
